import api from '@/api/api.js'

export const SettingsApi = {
  async fetchOrgSettings() {
    // Returns null if not set yet
    const res = await api.get('/settings/')
    return res.data
  },
  async saveOrgSettings(payload) {
    // payload: { currency_code, timezone, plan }
    const res = await api.put('/settings/', payload)
    return res.data
  }
}

export default SettingsApi
